/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_No_ItemsInputs */

const en_zotero_browser_no_items = /** @type {(inputs: Zotero_Browser_No_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items with supported attachments found.`)
};

const es_zotero_browser_no_items = /** @type {(inputs: Zotero_Browser_No_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron elementos con adjuntos compatibles.`)
};

/**
* | output |
* | --- |
* | "No items with supported attachments found." |
*
* @param {Zotero_Browser_No_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_no_items = /** @type {((inputs?: Zotero_Browser_No_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_No_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_no_items(inputs)
	return en_zotero_browser_no_items(inputs)
});